<template>
  <draggable v-model="sortableImages" tag="v-row" ghost-class="ghost" class='mx-1 my-3' style='justify-content: start;'>
    <div
      v-for="(image, index) in sortableImages"
      :key="index"
      class="productImage__wrapper"
    >
      <v-card class="ma-2">
        <v-layout justify-center>
          <v-img
            :src="imageSrc(multipleProductImageUrl(image))"
            min-height="100"
            max-height="200"
            max-width="185"
            class="ma-2"
          >
            <span class="p-imageCard__removeBtn">
              <v-icon medium @click="removeImage(index)">mdi-close</v-icon>
            </span>
            <span class="p-imageCard__priority">
              {{ index + 1 }}
            </span>
          </v-img>
        </v-layout>
        <v-text-field
          :value="assignReferenceUrl(image)"
          label="画像引用URL"
          dense
          :rules="[urlValidation]"
          class="ma-2"
          @input="updateReferenceUrl($event, index)"
        >
        </v-text-field>
      </v-card>
    </div>
  </draggable>
</template>

<script>
import imageUtilsMixin from '@/mixins/image_utils'
import formValidationUtils from '@/mixins/form_validation_utils'
import draggable from 'vuedraggable'

export default {
  name: 'SortImages',
  components: {
    draggable
  },
  mixins: [imageUtilsMixin, formValidationUtils],
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  computed: {
    sortableImages: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('change', value)
      }
    }
  },
  methods: {
    assignReferenceUrl (image) {
      return image.referenceUrl
    },
    updateReferenceUrl (url, index) {
      this.$emit('change-reference-url', url, index)
    },
    removeImage (index) {
      this.$emit('remove-image', index)
    }
  }
}
</script>

<style scoped>
.p-imageCard__priority {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 25px;
  height: 25px;
  text-align: center;
  background-color: #ddd;
  font-weight: bold;
}

.p-imageCard__removeBtn {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  width: 25px;
  height: 25px;
  text-align: center;
  background-color: #ddd;
  font-weight: bold;
}
</style>
